<script lang="ts" generics="ITEM">
    import {exists} from 'shared/utils/custom-utils';
import type {Observable} from 'rxjs';
import type {Pagination, PaginationData} from '../search-manager/pagination';
import KpSearchResultsLoadingContent from './KpSearchResultsLoadingContent.svelte';
import type {ComponentSize} from 'shared/ui-widgets/types';

    export let pagination: Pagination<ITEM>;
    export let loadingSize: ComponentSize = 'md';

    let paginationData: Observable<PaginationData<ITEM>>
    $: paginationData = pagination.getPaginationData$()
</script>

{#if exists($paginationData)}
    <KpSearchResultsLoadingContent paginationData={$paginationData} {loadingSize}>
        <slot paginationData={$paginationData}></slot>
    </KpSearchResultsLoadingContent>
{/if}
